import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Container, Dimmer, Loader } from "semantic-ui-react";
import RegionCreateForm from "./RegionCreateForm";
import VoiceRegionDetail from "./RegionDetail";
import RegionList from "./RegionList";
type RegionViewProps = {
  selectView: Function;
};

const RegionView = ({ selectView }: RegionViewProps) => {
  const { voiceRegion, loading, create } = useVoiceRegion();
  return (
    <Container fluid>
      <Dimmer.Dimmable dimmed={loading}>
        <div style={{ minHeight: "200px" }}>
          {!voiceRegion && !create && <RegionList selectView={selectView} />}
          {voiceRegion && <VoiceRegionDetail />}
          {!voiceRegion && create && <RegionCreateForm />}
        </div>
        <Dimmer inverted active={loading}>
          <Loader />
        </Dimmer>
      </Dimmer.Dimmable>
    </Container>
  );
};

export default RegionView;
